<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="12">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('标题')" prop="title">
                <a-input v-model="queryParam.title" :maxLength="32" :placeholder="$t('请输入')+$t('标题')" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('频道')" prop="channelId">
                <a-select :placeholder="$t('请选择')" v-model="queryParam.channelId" allowClear>
                  <a-select-option v-for="item in channelList" :key="item.id" :value="item.id">{{ item.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('状态')" prop="postStatus">
                <a-select :placeholder="$t('请选择')" v-model="queryParam.postStatus" allowClear>
                  <a-select-option v-for="item in customDict.PostStatusEnum" :key="item.type" :value="item.type">{{ $t(item.name) }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('话题')" prop="topicName">
                <a-input v-model="queryParam.topicName" :maxLength="32" :placeholder="$t('请输入')" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('类型')" prop="contentType">
                <a-select :placeholder="$t('请选择')" v-model="queryParam.contentType" allowClear>
                  <a-select-option :value="1">{{$t('帖子图文类型')}}</a-select-option>
                  <a-select-option :value="2">{{$t('帖子视频类型')}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('上架状态')" prop="shelfStatus">
                <a-select :placeholder="$t('请选择')" v-model="queryParam.shelfStatus" allowClear>
                  <a-select-option v-for="item in customDict.PostShelfStatusEnum" :key="item.type" :value="item.type">{{ $t(item.name) }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('创建开始时间')" prop="createBeginTime">
                <a-date-picker style="width: 100%" v-model="queryParam.createBeginTime"
                               :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}"
                               valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('创建结束时间')" prop="createEndTime">
                <a-date-picker style="width: 100%" v-model="queryParam.createEndTime"
                               :show-time="{defaultValue: moment('23:59:59', 'HH:mm:ss')}"
                               valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="!advanced && 6 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('查询') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('重置') }}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" :disabled="multiple" @click="handleBatchPass(null)" v-hasPermi="['discovery:discoverypost:edit']">
          {{ $t('审核通过') }}
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleBatchRejectShow(null)" v-hasPermi="['discovery:discoverypost:edit']">
          {{ $t('审核拒绝') }}
        </a-button>
        <a-button type="primary" :disabled="single" @click="handleBatchRecommend(null)" v-hasPermi="['discovery:discoverypost:edit']">
          {{ $t('设置推荐') }}
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleBatchCancelRecommend(null)" v-hasPermi="['discovery:discoverypost:edit']">
          {{ $t('取消推荐') }}
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
        :scroll="{ x: '160%', y: tableScrollY }"
      >
        <template slot="contentType" slot-scope="text, record">
          <span v-if="record.contentType === 1">{{ $t('帖子图文类型') }}</span>
          <span v-else-if="record.contentType === 2">{{ $t('帖子视频类型') }}</span>
        </template>
        <template slot="channelList" slot-scope="text, record">
          <span v-if="record.channelList && record.channelList.length > 0">{{ record.channelList.join('、') }}</span>
        </template>
        <template slot="topicList" slot-scope="text, record">
          <span v-if="record.topicList && record.topicList.length > 0">{{ record.topicList.join('、') }}</span>
        </template>
        <template slot="mediaUrls" slot-scope="text, record">
          <div style="width:40px;height:40px;">
            <img
              v-if="record.contentType === 1 && record.mediaUrls && record.mediaUrls.length > 0"
              :src="record.mediaUrls[0]"
              style="width:40px;height:40px;"
              @click="handleRecordPreview(record.mediaUrls[0])"
              alt="none"
            />
          </div>
        </template>
        <span slot="isRecommend" slot-scope="text, record">
           <custom-dict-tag :options="customDict.TFEnum"  :color="true"   :value="record.isRecommend"/>
        </span>
        <span slot="shelfStatus" slot-scope="text, record">
           <custom-dict-tag :options="customDict.PostShelfStatusEnum"  :color="true"   :value="record.shelfStatus"/>
        </span>
        <span slot="postStatus" slot-scope="text, record">
           <custom-dict-tag :options="customDict.PostStatusEnum"  :color="true"   :value="record.postStatus"/>
        </span>
        <span slot="publishTime" slot-scope="text, record">
          {{ parseTime(record.publishTime) }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="updateTime" slot-scope="text, record">
          {{ parseTime(record.updateTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="handleDelete(record)" v-hasPermi="['discovery:discoverypost:remove']">
            {{ $t('删除') }}
          </a>
          <a-divider type="vertical" />
          <a @click="$refs.createForm.handleUpdate(record)" >
            {{ $t('查看详情') }}
          </a>

          <template>
            <br>
            <a @click="handleBatchPass(record)"  v-if="record.postStatus===2" v-hasPermi="['discovery:discoverypost:edit']">
              {{ $t('审核通过') }}
            </a>
            <a-divider type="vertical" v-if="record.postStatus===2"  v-hasPermi="['discovery:discoverypost:edit']" />
            <a @click="handleBatchRejectShow(record)"  v-if="record.postStatus===2" style="color: red;" v-hasPermi="['discovery:discoverypost:edit']">
              {{ $t('审核拒绝') }}
            </a>
          </template>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>

    <reject-modal
      :visible="rejectModalVisible"
      :onReject="handleBatchReject"
      @cancel="rejectModalVisible = false"
    />
  </page-header-wrapper>
</template>

<script>
import {
  pageDiscoveryPost,
  delDiscoveryPost,
  batchPassDiscoveryPost,
  batchRejectDiscoveryPost,
  batchRecommendDiscoveryPost,
  batchCancelRecommendDiscoveryPost
} from '@/api/discovery/discoveryPost'
import CustomDictTag from '@/components/DictCustomTag'
import { mapGetters } from 'vuex'
import moment from 'moment'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import { listDiscoveryChannelCategory } from '@/api/discovery/discoveryChannelCategory'
import { parseTime } from '@/utils/ruoyi'
import RejectModal from '@/components/RejectModal/index.vue'

export default {
  name: 'DiscoveryPost',
  components: {
    RejectModal,
    CustomDictTag,
    CreateForm
  },
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo: {},
      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        id: undefined,
        userId: undefined,
        authorName: undefined,
        title: undefined,
        content: undefined,
        contentType: undefined,
        mediaUrls: undefined,
        isRecommend: undefined,
        shelfStatus: undefined,
        postStatus: undefined,
        machineStatus: undefined,
        machineScore: undefined,
        machineLabels: undefined,
        humanStatus: undefined,
        rejectReason: undefined,
        publishTime: undefined,
        viewCnt: undefined,
        commentCnt: undefined,
        likeCnt: undefined,
        collectCnt: undefined,
        topicName: undefined,
        channelId: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: 'ID',
          dataIndex: 'id',
          ellipsis: true,
          align: 'center',
          fixed: 'left'
        },
        {
          title: this.$t('标题'),
          dataIndex: 'title',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('作者'),
          dataIndex: 'authorName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('类型'),
          dataIndex: 'contentType',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'contentType' }
        },
        {
          title: this.$t('频道'),
          dataIndex: 'channelList',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'channelList' }
        },
        {
          title: this.$t('话题'),
          dataIndex: 'topicList',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'topicList' }
        },
        {
          title: this.$t('封面图'),
          dataIndex: 'mediaUrls',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'mediaUrls' }
        },
        {
          title:  this.$t('浏览量'),
          dataIndex: 'viewCnt',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('评论量'),
          dataIndex: 'commentCnt',
          ellipsis: true,
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          align: 'center'
        },
        {
          title: this.$t('点赞量'),
          dataIndex: 'likeCnt',
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('收藏量'),
          dataIndex: 'collectCnt',
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('推荐'),
          dataIndex: 'isRecommend',
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'isRecommend' }
        },
        {
          title: this.$t('上架状态'),
          dataIndex: 'shelfStatus',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'shelfStatus' }
        },
        {
          title: this.$t('状态'),
          dataIndex: 'postStatus',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'postStatus' }
        },
        {
          title:  this.$t('拒绝原因'),
          dataIndex: 'rejectReason',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('发布时间'),
          dataIndex: 'publishTime',
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          scopedSlots: { customRender: 'publishTime' },
          ellipsis: true,
          align: 'center',
          width: '180px'
        },
        {
          title: this.$t('操作'),
          dataIndex: 'operation',
          width: '180px',
          scopedSlots: { customRender: 'operation' },
          align: 'center',
          fixed: 'right'
        }
      ],
      channelList: [],
      rejectModalVisible: false
    }
  },
  filters: {},
  created() {
    this.getList()
    this.getChannelList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {},
  methods: {
    parseTime,
    moment,
    getTotal(total) {
      return this.$t('共') + total + this.$t('条')
    },
    getChannelList() {
      listDiscoveryChannelCategory({}).then(response => {
        this.channelList = response.data
      })
    },
    /** 查询发现-帖子列表 */
    getList() {
      this.loading = true
      pageDiscoveryPost(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        id: undefined,
        userId: undefined,
        authorName: undefined,
        title: undefined,
        content: undefined,
        contentType: undefined,
        mediaUrls: undefined,
        isRecommend: undefined,
        shelfStatus: undefined,
        postStatus: undefined,
        machineStatus: undefined,
        machineScore: undefined,
        machineLabels: undefined,
        humanStatus: undefined,
        rejectReason: undefined,
        publishTime: undefined,
        viewCnt: undefined,
        commentCnt: undefined,
        likeCnt: undefined,
        collectCnt: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        if (this.queryParam.sortField === 'createTime') {
          this.queryParam.sortField = 'id'
        }
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = ''
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids = []
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('确认删除所选中数据'),
        onOk() {
          let data = []
          that.ids.map(id => data.push({ 'id': id }))
          return delDiscoveryPost(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              const message = that.$t('删除成功')
              that.$message.success(
                message,
                3
              )
            })
        },
        onCancel() {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: this.$t('是否确认导出'),
        content: this.$t('此操作将导出当前条件下所有数据而非选中数据'),
        onOk() {
          that.download('discovery/discovery/post/export',
            that.queryParam
            , `post_${new Date().getTime()}.xlsx`)
        },
        onCancel() {
        }
      })
    },
    handleBatchPass(row) {
      var that = this
      if (row?.id) {
        this.ids = []
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('确认通过选中数据'),
        onOk() {
          const data = []
          that.ids.map(id => data.push({ 'id': id }))
          return batchPassDiscoveryPost(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              const message = that.$t('审核成功')
              that.$message.success(
                message,
                3
              )
            })
        },
        onCancel() {
          // 取消清空删除ids列表
          that.ids = []
        }
      })
    },
    handleBatchRejectShow(row) {
      if (row?.id) {
        this.ids = []
        this.ids.push(row.id)
      }
      var that = this
      this.$confirm({
        title: this.$t('确认拒绝选中数据'),
        onOk() {
          that.rejectModalVisible = true
        },
        onCancel() {
          // 取消清空删除ids列表
          that.ids = []
          that.rejectModalVisible = false
        }
      })
    },
    handleBatchReject(reason) {
      var that = this
      const data = []
      that.ids.map(id => data.push(id))
      return batchRejectDiscoveryPost({ ids: data, reason: reason })
        .then(() => {
          that.onSelectChange([], [])
          that.getList()
          const message = that.$t('拒绝成功')
          that.$message.success(
            message,
            3
          )
          this.rejectModalVisible = false
        }).catch(() => {
          this.rejectModalVisible = false
        })
    },
    handleBatchRecommend(row) {
      var that = this
      if (row?.id) {
        this.ids = []
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('确认推荐选中数据？'),
        onOk() {
          const data = []
          that.ids.map(id => data.push({ 'id': id }))
          return batchRecommendDiscoveryPost(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              const message = that.$t('推荐成功')
              that.$message.success(
                message,
                3
              )
            })
        },
        onCancel() {
          // 取消清空删除ids列表
          that.ids = []
        }
      })
    },
    handleBatchCancelRecommend(row) {
      var that = this
      if (row?.id) {
        this.ids = []
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('确认取消推荐选中数据？'),
        onOk() {
          const data = []
          that.ids.map(id => data.push({ 'id': id }))
          return batchCancelRecommendDiscoveryPost(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              const message = that.$t('取消成功')
              that.$message.success(
                message,
                3
              )
            })
        },
        onCancel() {
          // 取消清空删除ids列表
          that.ids = []
        }
      })
    }
  }
}
</script>
